import angular from 'angular';
import uiRouter from 'angular-ui-router';
import Common from './common/common';
import Containers from './containers/containers';
import AppComponent from './app.component';
import c from "./utils/constants";
import 'normalize.css';
import env from "./utils/env";

angular.module('app', [
    uiRouter,
    Common.name,
    Containers.name,
    "kendo.directives"
  ])
  .config(($locationProvider) => {
    'ngInject';
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');
  })

  .run(($rootScope, $window, $state, $location, AuthService, AppContextService, EventsService) => {
     'ngInject';
    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      let defaultState = env.defaultState();
      let pageTitle = env.pageTitle();

      $window.document.title = pageTitle;

      if (toState.name != 'login') {
        if (!AuthService.isAuthorized()) {
            console.log("Access denied");
            $state.go('login');
            event.preventDefault();
        }
        else {
          if(!AppContextService.getAppContext()) {
            AppContextService.fetchAppContext((response) => {
              const roles = response.data.roles;

              if(AppContextService.hasAccess(roles)) {

                AppContextService.setAppContext(response.data);
                EventsService.broadcast(c.events.AUTHORIZATION_SUCCESS);

                if(AppContextService.hasReadAccess(roles)) {

                  if(toState.name != defaultState)
                    $state.go(defaultState);
                }

              } else {
                $state.go("login");
              }
            },
            () => {
              $state.go("login");
            })

          } else {

            const roles = AppContextService.getAppContext().roles;

            if(AppContextService.hasReadAccess(roles)) {
              // Allow navigation to all admin states, only redirect analytics users to analytics
              if(toState.name.indexOf("analytics") == -1 && env.isAnalytics()) {
                  event.preventDefault();
                  $state.go(defaultState);
              }
            }
          }
        }
      }

    });

    if ($location.path() == "/") {
      let defaultState = env.defaultState();
      $state.go(defaultState);
    }

  })

  .component('app', AppComponent);



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/app.js
 **/